import Marquee from "react-fast-marquee";

const items = ["Corporate Headshots", "Business Branding", "Concerts", "Live Events", "Editorial"];

const MarqueeStrip = () => (
  <section data-testid="marquee-strip" className="border-y border-white/10 py-8 md:py-12 bg-[#050505]">
    <Marquee speed={45} gradient={false} autoFill>
      {items.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-serif italic text-5xl md:text-7xl lg:text-8xl text-stroke px-8">
            {t}
          </span>
          <span className="text-[#F5A623] text-4xl md:text-6xl px-2">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default MarqueeStrip;
